<template>
    <div>
        <Toolbar>
            <BackButton :to="__('subscriptions.features')" :href="$route('subscriptions.features')"/>
        </Toolbar>

        <Card>
            <template v-slot:title>
                {{ __('actions.edit_thing', {thing: __('subscriptions.feature')}) }}
            </template>
            <template v-slot:description>
                {{ feature.name }}
            </template>
            <template v-slot:toolbar>
                <div class="btn-group btn-group-sm">
                    <Link as="button"
                          class="btn btn-sm btn-outline-secondary btn-hover-primary"
                          :href="$route('subscriptions.pricing.edit', ['feature', feature.id])">
                        <i class="fas fa-edit mr-1"/>
                        {{ __('actions.edit_thing', {thing: __('general.pricing_model')}) }}
                    </Link>
                    <button class="btn btn-sm btn-outline-secondary btn-hover-danger" disabled>
                        <i class="fas fa-trash mr-1"/>
                        {{ __('actions.delete') }}
                    </button>
                </div>
            </template>
            <template v-slot:default>
                <h3>
                    {{ __('general.pricing_model') }}
                </h3>
                <div class="row">
                    <div v-for="priceGroup in priceGroups" class="col-md-4"
                         :class="{'border-left': priceGroup !== 'all'}">
                        <div class="font-weight-bold font-size-lg text-primary">
                            {{ __('subscriptions.pricing_groups.' + priceGroup) }}
                        </div>
                        <div v-if="feature.pricing_groups.hasOwnProperty(priceGroup)">
                            <PricingGroup :name="priceGroup" :pricings="feature.pricing_groups[priceGroup]"/>
                        </div>
                        <div v-else>
                            Noch keine Einträge
                        </div>
                    </div>
                </div>

                <!--                <div class="mt-1">-->
                <!--                    <Link as="button" :href="$route('subscriptions.features.edit', feature.id)" class="btn btn-outline-primary">-->
                <!--                        <i class="fas fa-edit mr-1"/>-->
                <!--                        {{ __('actions.edit_thing', {thing: __('general.pricing_model')}) }}-->
                <!--                    </Link>-->
                <!--                </div>-->
            </template>
        </Card>
    </div>
</template>

<script>
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import { Link } from '@inertiajs/vue2';
import Productable from "@components/Subscriptions/Productable.vue";
import Card from "@components/Cards/Card.vue";
import PricingGroup from "@components/Subscriptions/Pricing/PricingGroup.vue";
export default {
    components: {PricingGroup, Card, Productable, BackButton, Toolbar, Link},

    props: {
        feature: Object
    },

    data() {
        return {
            priceGroups: ['all', 'flex', 'fixed']
        }
    }
}
</script>
